import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Section = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3, 4),
  display: 'flex',
  gap: theme.spacing(4),
  flexDirection: 'column',
}));
